export default data => {
  let errors = {};

  if ( !data.link && !data.youtube && !data.instagram && !data.file ) errors.form = 'Вкажіть хоча би одне посилання';

  return errors;
}
